import { useCallback } from "react";

import {
	getMeetingsFlattened,
	OutputRow as MeetingsFlattenedData
} from "api/getMeetingsFlattened";
import {
	getMeetingRequests,
	OutputRow as MeetingRequestsData
} from "api/getMeetingRequests";
import {
	getMeetingRescheduleRequests,
	OutputRow as MeetingRescheduleRequestsData
} from "api/getMeetingRescheduleRequests";
import { useFetchPurchases } from "components/PageDashboard/useFetchPurchases";

type Event =
	| MeetingsFlattenedData
	| MeetingRequestsData
	| MeetingRescheduleRequestsData;

export function useFetchEvents() {
	const apiRequests = useCallback(
		(isMentor: boolean | undefined, uid: string) => {
			const earliestStartDateUTC = new Date();
			return [
				// Upcoming meetings, fully paid (user is guest)
				getMeetingsFlattened(
					{
						guestUid: uid,
						earliestStartDateUTC,
						paymentStatus: "ok"
					},
					{ uid }
				),
				getMeetingsFlattened(
					{
						guestUid: uid,
						earliestStartDateUTC,
						paymentStatus: "free"
					},
					{ uid }
				),

				// Upcoming meetings, fully paid (user is host)
				...(!!isMentor
					? [
							getMeetingsFlattened(
								{
									hostUid: uid,
									earliestStartDateUTC,
									paymentStatus: "ok"
								},
								{ uid }
							),
							getMeetingsFlattened(
								{
									hostUid: uid,
									earliestStartDateUTC,
									paymentStatus: "free"
								},
								{ uid }
							)
					  ]
					: []),

				// Any meetings that require payment (user is guest)
				getMeetingsFlattened(
					{
						guestUid: uid,
						paymentStatus: "pending"
					},
					{ uid }
				),

				// Any meetings that require payment (user is host)
				...(isMentor
					? [
							getMeetingsFlattened(
								{
									hostUid: uid,
									paymentStatus: "pending"
								},
								{ uid }
							)
					  ]
					: []),

				// Any finished meetings that require guest confirmation
				getMeetingsFlattened(
					{
						guestUid: uid,
						isSignedOff: "0",
						mustEndBeforeUTC: new Date()
					},
					{ uid }
				),

				// Upcoming meetings awaiting host confirmation
				getMeetingRequests(
					{
						guestUid: uid,
						earliestStartDateUTC,
						isAccepted: false,
						isRejected: false
					},
					{ uid }
				),

				// Meetings with reschedule requested  (user is host)
				getMeetingRescheduleRequests(
					{
						hostUid: uid,
						earliestStartDateUTC,
						isAccepted: false,
						isRejected: false
					},
					{ uid }
				),

				// Meetings with reschedule requested  (user is guest)
				getMeetingRescheduleRequests(
					{
						guestUid: uid,
						earliestStartDateUTC,
						isAccepted: false,
						isRejected: false
					},
					{ uid }
				)
			];
		},
		[]
	);

	return useFetchPurchases<Event>(apiRequests, "meetings-combined");
}
